import { Flex, Typography } from 'antd';

import logo from 'assets/images/logo/logo-pub-short.svg';
import { Balance } from 'entities/User';
import { Logo } from 'shared/ui';
import { HeaderMenu } from 'widgets/Header';
import { useHeader } from 'widgets/Header/hooks/useHeader';

import styles from '../HeaderAdvertiser/Header.module.scss';
import { Notifications } from '../Notifications/Notifications';
import { UserInfo } from '../UserInfo/UserInfo';

export const HeaderPublisher = () => {
	const { isDesktop, isMobile, headerTitle } = useHeader(true);

	return (
		<Flex className={styles.header} gap={8} justify={'space-between'} align={'center'}>
			{isDesktop ? (
				<Typography.Title style={{ margin: 0 }} type="secondary" level={4}>
					{headerTitle}
				</Typography.Title>
			) : (
				<Logo image={logo} />
			)}
			<Flex align="center" gap="8px">
				{!isMobile && <Balance isPublisher={true}/>}
				<Notifications />
				<UserInfo isPublisher={true}/>
				{!isDesktop && <HeaderMenu isPublisher={true} />}
			</Flex>
		</Flex>
	);
};
